export const sanitizeRedirectPath = (
  redirect,
  { defaultPath = "/", loginPath = "/login" } = {}
) => {
  if (!redirect) return defaultPath;

  try {
    const url = new URL(redirect, window.location.origin);
    if (url.origin !== window.location.origin) return defaultPath;

    const nextPath = `${url.pathname}${url.search}${url.hash}`;
    if (url.pathname === loginPath) return defaultPath;

    return nextPath || defaultPath;
  } catch {
    return defaultPath;
  }
};

const USER_GATE_PATHS = new Set([
  "/login",
  "/logout",
  "/pagamento",
  "/banido",
  "/renovacao",
]);

export const sanitizeAuthenticatedRedirectPath = (
  redirect,
  { defaultPath = "/", loginPath = "/login" } = {}
) => {
  const nextPath = sanitizeRedirectPath(redirect, { defaultPath, loginPath });

  try {
    const url = new URL(nextPath, window.location.origin);
    const normalizedPathname = url.pathname.replace(/\/+$/, "") || "/";
    if (USER_GATE_PATHS.has(normalizedPathname)) return defaultPath;
    return nextPath === "/" ? defaultPath : nextPath;
  } catch {
    return defaultPath;
  }
};

export const getCurrentRedirectPath = ({
  defaultPath = "/",
  loginPath = "/login",
} = {}) =>
  sanitizeRedirectPath(
    `${window.location.pathname}${window.location.search}${window.location.hash}`,
    { defaultPath, loginPath }
  );

export const buildLoginRedirectUrl = ({
  defaultRedirectPath = "/",
  loginPath = "/login",
} = {}) => {
  const redirect = getCurrentRedirectPath({
    defaultPath: defaultRedirectPath,
    loginPath,
  });

  return `${loginPath}?redirect=${encodeURIComponent(redirect)}`;
};
